<template>
  <div class="input-field" :class="{'horizontal' : horizontal}">
    <template v-if="!horizontal">
        <div class="heading" v-if="info">
            <span class="title" v-text="label"></span>
            <img v-if="toolTip" :src="getImage('question-icon.svg')" alt="" @click="openPopup">
        </div>
        <div class="heading" v-else>
            <span class="title" v-text="label"></span>
        </div>
    </template>
    <template v-else>
        <div class="horizontal-heading">
            <span class="title">{{ label }}</span>
        </div>
    </template>

    <div class="input-group" :class="{'has-suffix': suffix}">
      <input :type="type" class="form-control" :value="value" @input="change" :min="100" :class="{'error': error}">
      <span class="error" v-if="error">{{ $t('hose.minLengthError') }}</span>
      <div class="input-group-append" v-if="suffix">
        <span class="input-group-text" v-text="suffix"></span>
      </div>
    </div>
  </div>
</template>

<script>
import tooltipMixin from "@/mixins/tooltipMixin";

export default {
  name: "InputField",

  mixins: [tooltipMixin],

  props: {
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      required: true,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    suffix: {
      type: String,
      required: false,
    },
    value: {
      required: true,
    },
    info: {
      type: Boolean,
      default: true,
    },
    error: Boolean,
  },

  methods: {
    change(event) {
      this.$emit('change', event.target.value);
      this.$emit('input', event.target.value);
    },
    openPopup() {
      this.$store.commit('tooltips/setCurrentActive', this.toolTip);
    }
  },
}
</script>

<style scoped lang="scss">
.input-field.horizontal {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;

  .input-group {
    margin: 0;
    flex: 1 0 auto;
  }

  .horizontal-heading {
    margin-right: 16px;
    flex: 1 0 auto;

    .title {
      font-size: 14px;
      font-family: neue-haas-grotesk-display, sans-serif;
    }
  }
}

.heading {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    font-size: 14px;
    font-family: neue-haas-grotesk-display, sans-serif;
  }
}

.input-group {
  margin-top: 6px;
  margin-bottom: 13px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  min-width: 100px;

  input {
    border-radius: 50px;
    min-height: 40px;
    border: 2px solid #EBEBEB;
    font-size: 12px;
    outline: none;
    box-shadow: none;
    font-family: neue-haas-grotesk-text, sans-serif;
    flex-grow: 1;

    &.error {
      color: #cc0000;
    }
  }
  span.error {
    position: absolute;
    top: 45px;
    color: #cc0000;
    font-size: 10px;
    font-style: italic;
  }

  .input-group-text {
    background-color: #EBEBEB;
    max-width: 50px;
    text-align: center;
    border-radius: 0 50px 50px 0;
    border: none;
    font-size: 12px;
    font-family: neue-haas-grotesk-text, sans-serif;

    @media only screen and (max-width: 360px) {
      min-width: 20px;
    }
  }
}
</style>
